import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { ProductContext } from '../../App';
import DeleteIcon from '@mui/icons-material/Delete';

function Exchange(props) {

    const product_context = useContext(ProductContext);
    const { setIsLoading, setAlert, alert, } = product_context;

    const [products, setProducts] = useState();

    const [sellType, setSellType] = useState('online');

    const { exchangeSell, setExchangeSell } = props;

    const { isOpen, order } = exchangeSell;

    const [costumerDetails, setCostumerDetails] = useState({
        contactNo: '',
        customerName: '',
        instaId: '',
        address: '',
    })

    useEffect(() => {
        setCostumerDetails({
            contactNo: order?.customer_details?.contact_number || '',
            customerName: order?.customer_details?.name || '',
            instaId: order?.customer_details?.instagram_id || '',
            address: order?.customer_details?.address || ''
        })
    }, [order]);

    const [sellData, setSellData] = useState([{
        itemName: [], itemType: [], price: '', color: [], size: []
    }]);

    const [itemInp, setItemInp] = useState([{ itemName: '', itemType: '', price: '', color: '', size: '', product_id: '' }]);

    const addInputs = () => {
        const item = [...itemInp, { itemName: '', itemType: '', price: '', color: '', size: '', product_id: '' }];
        const sellItem = [...sellData, { itemName: [], itemType: [], price: '', color: [], size: [] }];

        setItemInp(item);
        setSellData(sellItem);
    }

    const itemType = [...new Set(products?.map(el => el.item_type))] || [''];

    const handleRemove = (e, i) => {
        e.preventDefault();
        let deletedData = [...sellData];
        let deletedata = [...itemInp];
        deletedData.splice(i, 1);
        deletedata.splice(i, 1);
        setSellData(deletedData);
        setItemInp(deletedata);
    }

    const handleChange = (e, i) => {
        const { name, value } = e.target;
        let inputSellData = [...itemInp];
        inputSellData[i][name] = value;

        let inputdata = [...sellData];
        if (name === 'itemType') {
            let itemName = [...new Set((products?.filter(item => item.item_type === value))?.map(el => el.item_name))];
            document.getElementById(`itemName${i}`).value = '';
            inputdata[i]['itemName'] = itemName;
        }
        else if (name === 'itemName') {
            let itemColor = [...new Set((products?.filter(item => item.item_type === itemInp[i].itemType && item.item_name === value))?.map(el => el.color))];
            document.getElementById(`color${i}`).value = '';
            inputdata[i]['color'] = itemColor;
        }
        else if (name === 'color') {
            let itemPrice = [...new Set(((products?.filter(item => item.item_type === itemInp[i].itemType && item.item_name === itemInp[i].itemName && item.color === value))?.map(el => el.price + el.additional_price)))][0] || 0;

            let itemSizetemp = (products?.filter(item => item.item_type === itemInp[i].itemType && item.item_name === itemInp[i].itemName && item.color === value))?.map(el => el.size);

            let productId = [...new Set(((products?.filter(item => item.item_type === itemInp[i].itemType && item.item_name === itemInp[i].itemName && item.color === value))?.map(el => el._id)))][0];

            let itemSizearray = [];
            for (let i = 0; i < itemSizetemp?.length; i++) {
                itemSizearray = itemSizearray.concat(itemSizetemp[i]);
            }

            let itemSize = [...itemSizearray];

            itemInp.forEach(el => {
                if (el.product_id === productId) {
                    if (el.size) {
                        let index = itemSize.indexOf(el.size);
                        itemSize.splice(index, 1);
                    }
                }
            })

            inputSellData[i]['product_id'] = productId;

            inputdata[i]['price'] = itemPrice;
            inputdata[i]['size'] = itemSize;
        }
        setSellData(inputdata);
        setItemInp(inputSellData);
    }

    let total_price = 0;
    itemInp.forEach(item => {
        total_price += Number(item.price);
    })

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/products`)
            .then(res => {
                let filtered_data = res.data.data.filter(el => el.quantity !== 0);
                setProducts(filtered_data);
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: 'Something Went Wrong',
                    type: 'danger'
                });
            })
        // eslint-disable-next-line
    }, [exchangeSell]);

    const handleExchangeSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let product_data = {
            purchase_type: sellType,
            customer_details: {
                name: e.target.customerName?.value ? e.target.customerName?.value : order.customer_details?.name || '',
                instagram_id: e.target.instaId?.value ? e.target.instaId?.value : order.customer_details?.instagram_id || '',
                address: e.target.address?.value ? e.target.address?.value : order.customer_details.address || '',
                contact_number: e.target.contactNo?.value ? e.target.contactNo?.value : order.customer_details.contact_number || '',
            },
            product_details: itemInp.map(product => {
                return {
                    product_id: product.product_id,
                    color: product.color,
                    size: product.size,
                    price: product.price,
                    name: product.itemName,
                    type: product.itemType,
                }
            }),
            delivery_instructions: e.target.deliveryInst?.value,
            order_date: new Date(),
            status: sellType === 'store' ? 'done' : 'pending',
            payment_method: e.target.payment_method.value,
            payment: e.target.payment_method.value === 'COD' || e.target.payment_method.value === 'Credit' ? "Pending" : 'Received',
        }

        let data = {
            product_data,
            order,
        }

        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/sell/exchange/${order._id}`, data)
            .then(res => {
                document.body.classList.remove('remove-scroll');
                setAlert({
                    isOpen: true,
                    message: "Product Exchanged",
                    type: 'success'
                });
                setSellType('online');
                setExchangeSell({ ...exchangeSell, isOpen: false });
                e.target.reset();
                setIsLoading(false);
                props.setChangeSellsState(!props.changeSellsState);
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: err.response.data?.msg,
                    type: 'danger'
                });
                setIsLoading(false);
            })
        setTimeout(() => {
            setAlert({ ...alert, isOpen: false })
        }, 5000);
    }

    const handleCustomerDetailsChange = (e) => {
        let { name, value } = e.target;
        setCostumerDetails({ ...costumerDetails, [name]: value });
    }

    return (
        <>
            {isOpen ? <div className='back'>
                <div className="edit-container flex-column">
                    <h2>Exchange</h2>
                    <div className="exchange">
                        {order?.purchase_type === 'online' ? <div>
                            <p><strong>Customer Name: </strong>{order?.customer_details?.name}</p>
                        </div> : null}
                        <p><strong>Previous Item: </strong>{order?.product_details?.item_type + '-' + order?.product_details?.item_name + '-' + order?.color + '-' + order?.size}</p>
                        <p><strong>Price:</strong>{order?.price}</p>
                    </div>
                    <div className="d-flex">
                        <div className="form-check form-check-inline">
                            <input onChange={() => { setSellType('online') }} defaultChecked className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="online" />
                            <label className="form-check-label" htmlFor="inlineRadio1">Online</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input onChange={() => { setSellType('store') }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="store" />
                            <label className="form-check-label" htmlFor="inlineRadio2">Store</label>
                        </div>
                    </div>

                    <div className="edit-form">
                        <form onSubmit={handleExchangeSubmit}>
                            <div className="overflow-handle flex-column">
                                <div className="inputs">
                                    <label htmlFor="customerName">Customer Name</label>
                                    <input type="text" value={costumerDetails.customerName}
                                        placeholder='Enter Customer Name' name='customerName' onChange={handleCustomerDetailsChange} />
                                </div>
                                {sellType === 'online' ? <div className="customer">

                                    <div className="inputs">
                                        <label htmlFor="instaId">Intagram ID</label>
                                        <input type="text" value={costumerDetails.instaId}
                                            placeholder='Enter Instagram ID' name='instaId' onChange={handleCustomerDetailsChange} />
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="address">Address</label>
                                        <input required type="text" value={costumerDetails.address}
                                            placeholder='Enter Customer Address' name='address' onChange={handleCustomerDetailsChange} />
                                    </div>
                                    <div className="inputs">
                                        <label required htmlFor="contactNo">Contact No</label>
                                        <input type="number" value={costumerDetails.contactNo}
                                            placeholder='Enter Contact Number' name='contactNo' onChange={handleCustomerDetailsChange} />
                                    </div>
                                </div> : null}

                                {sellData?.map(((item, i) => {
                                    return <div className="items" key={i}>
                                        <h5>Item-{i + 1}</h5>
                                        {i !== 0 ? <DeleteIcon className="fa-solid fa-trash remove" onClick={(e) => handleRemove(e, i)}></DeleteIcon> : null}
                                        <div className="inputs">
                                            <label htmlFor="itemType">Item Type</label>
                                            <select required onChange={(e) => handleChange(e, i)} className="form-select" name='itemType' aria-label="Default select example">
                                                <option value=''>Type</option>
                                                {itemType?.map((type, i) => {
                                                    return <option key={i} value={type}>{type}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className="inputs">
                                            <label htmlFor="itemName">Item Name</label>
                                            <select id={`itemName${i}`} required onChange={(e) => handleChange(e, i)} className="form-select" name='itemName' aria-label="Default select example">
                                                <option defaultChecked value=''>Name</option>
                                                {sellData[i]?.itemName?.map((type, i) => {
                                                    return <option key={i} value={type}>{type}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className="inputs">
                                            <label htmlFor="color">Color</label>
                                            <select id={`color${i}`} required onChange={(e) => handleChange(e, i)} className="form-select" name='color' aria-label="Default select example">
                                                <option defaultChecked value=''>Color</option>
                                                {sellData[i]?.color?.map((type, i) => {
                                                    return <option key={i} value={type}>{type}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className="inputs">
                                            <label htmlFor="size">Size</label>
                                            <select required onChange={(e) => handleChange(e, i)} className="form-select" name='size' aria-label="Default select example">
                                                <option defaultChecked value=''>Size</option>
                                                {sellData[i]?.size?.map((type, i) => {
                                                    return <option key={i} value={type}>{type}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className="inputs">
                                            <label htmlFor="price">Price</label>
                                            <input required onChange={(e) => handleChange(e, i)} type="number"
                                                placeholder='Enter Price' name='price' />
                                        </div>
                                    </div>
                                }))}
                                <button type='button' onClick={() => addInputs()} className='btn btn-secondary mb-3'>Add More</button>

                                <div className="inputs">
                                    <label htmlFor="deliveryInst">Delivery Instructions</label>
                                    <input type="text"
                                        placeholder='Enter Delivery Instructions' name='deliveryInst' />
                                </div>

                                <div className="inputs">
                                    <label htmlFor="payment_method">Payment Method</label>
                                    <select
                                        required
                                        className="form-select"
                                        name="payment_method"
                                        aria-label="Default select example"
                                    >
                                        <option value="Cash">Cash</option>
                                        <option value="COD">COD</option>
                                        <option value="Online">Online</option>
                                        <option value="Credit">Credit</option>
                                    </select>
                                </div>

                                <p><strong>Total Price:</strong>{total_price}</p>
                                <div className="text-center">
                                    <button className=' btn btn-primary mb-5 mx-2' type="submit">
                                        Submit
                                    </button>
                                    <button onClick={() => {
                                        setExchangeSell({ ...exchangeSell, isOpen: false });
                                        document.body.classList.remove('remove-scroll');
                                        setSellType('online');
                                    }} className='btn btn-danger mb-5'>Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div> : null}
        </>
    )
}

export default Exchange
